import { Grid } from "@mui/material";
import LabeledValue from "@/components/LabeledValue";
import DetailCard from "./DetailCard";
import {
  GROUP_DETAIL_FIELD_LABEL,
  GROUP_DETAIL_LABEL,
  GROUP_TYPE_OPTIONS,
  THERAPY_CATEGORY_OPTIONS,
} from "../group-visit-constant";
import { GroupDetail } from "../group-visit-types";
import { getOptionLabel, joinDetailParts } from "../group-visit-utils";

export type GroupInformationCardProps = {
  group: GroupDetail;
};

/**
 * @author Rajkumar Rathod
 */
const GroupInformationCard = ({ group }: GroupInformationCardProps) => {
  return (
    <DetailCard title={GROUP_DETAIL_LABEL.informationCard}>
      <Grid container spacing={2}>
        <Grid
          size={{
            xs: 12,
            md: 6,
          }}
        >
          <LabeledValue
            label={GROUP_DETAIL_FIELD_LABEL.groupName}
            value={group.groupName}
          />
        </Grid>

        <Grid
          size={{
            xs: 12,
            md: 6,
          }}
        >
          <LabeledValue
            label={GROUP_DETAIL_FIELD_LABEL.typeCategory}
            value={joinDetailParts([
              getOptionLabel(GROUP_TYPE_OPTIONS, group.groupType),
              getOptionLabel(THERAPY_CATEGORY_OPTIONS, group.therapyCategory),
            ])}
          />
        </Grid>

        <Grid
          size={{
            xs: 12,
            md: 6,
          }}
        >
          <LabeledValue
            label={GROUP_DETAIL_FIELD_LABEL.capacity}
            value={joinDetailParts([
              group.maxCapacity ? `${group.maxCapacity} members` : undefined,
              group.cptCode,
            ])}
          />
        </Grid>

        <Grid size={12}>
          <LabeledValue
            label={GROUP_DETAIL_FIELD_LABEL.description}
            value={group.description}
          />
        </Grid>
      </Grid>
    </DetailCard>
  );
};

export default GroupInformationCard;
